import {PureComponent} from 'react';
import {join, PropsOf} from '../../../utils';
import {Modal} from '../../modal';

import styles from './alert.module.less';

export type AlertProps = PropsOf<typeof Modal>;

export class Alert extends PureComponent<AlertProps> {
	public override render() {
		const {className, containerClassName, ...props} = this.props;
		return <Modal {...props}
		              unmountOnHide
		              className={join(styles.alert, className)}
		              containerClassName={join(styles.alertContainer, containerClassName)}>
			{this.props.children}
		</Modal>;
	}
}

export default Alert;
